import React from 'react'
import PropTypes from 'prop-types'
import { Container, Row, Col } from 'reactstrap'
import { FormattedMessage } from 'react-intl'
import EventsTracker from '../../../helpers/eventsTracker'

const eventsTracker = new EventsTracker()

const UnchargedStatus = React.memo(({ cart }) => {
  React.useEffect(() => {
    try {
      eventsTracker.checkoutSuccess(cart)
    } catch (e) {
      console.log('Error while login event in eventsTracker', e)
    }
  }, [cart])

  return (
    <div>
      <Container className='order-status mt-5'>
        <Row className='justify-content-center'>
          <Col md='10' className='text-center'>
            <h3>
              <FormattedMessage id='checkoutUncharged.header' />
            </h3>
            <p>
              <FormattedMessage id='checkoutUncharged.message' />
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  )
})

UnchargedStatus.displayName = 'UnchargedStatus'

UnchargedStatus.propTypes = {
  cart: PropTypes.object.isRequired
}

export default UnchargedStatus
